import { Link } from 'react-router-dom';

export default function QuoteCTA({ title, text, action = 'Contact us' }) {
  return (
    <section className="mx-cta tablet:px-6 tablet:py-[72px] tablet:flex-wrap">
      <div className="mx-cta-copy">
        <h2 className="m-0 font-display text-[44px] font-semibold leading-[1.1] tablet:text-[32px]">{title}</h2>
        <p className="m-0 max-w-[620px] text-[18px] leading-[1.6]">{text}</p>
      </div>
      <Link to="/contact" className="mx-cta-link">{action}</Link>
    </section>
  );
}
